import { Card, Loading, Table, Typography } from "@creditsafe/ui-components";
import { Edit as EditIcon } from "@mui/icons-material";
import {
  Box,
  Chip,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  ListItemText,
  MenuItem,
  Typography as MuiTypography,
  RadioGroup,
  TextField,
  FormGroup,
  Alert,
  Stepper,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import styled from "styled-components";
import Button from "../components/button/Button";
import DownloadIcon from "@mui/icons-material/Download";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export const EXPIRED_OPACITY = 0.5;

export const StyledChip = styled(Chip)`
  margin: 2px 4px 2px 0;
  &.Mui-disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const StyledBox = styled(Box)`
  &.MuiBox-root {
    border: 1px solid #cbcbcb;
  }
`;

export const StyledTableRow = styled(Table.Row)`
  height: 5rem;
`;

export const StyledDatasetTableCell = styled(Table.Cell)`
  width: 250px;
`;

export const StyledImage = styled.img`
  height: 50px;
  width: 50px;
  cursor: pointer;
`;

export const StyledEditIcon = styled(EditIcon)`
  height: 1rem;
  color: grey;
`;

export const DownloadButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 1rem;
  height: 3rem;
`;

export const DefaultRightDownloadButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 1rem;
  height: 3rem;
  margin-left: auto;
`;

export const DefaultBorderButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 7px;
  border-radius: 11px;
  height: 25px;
`;

export const DefaultErrorMessage = styled.div`
  color: ${(props) => props.theme.primaryColor};
  font-size: 11px;
  margin: 4px 2px 0;
`;

export const DefaultSaveUpdatesButton = styled(Button)`
  cursor: pointer;
  border: 1px solid #cbcbcb;
  border-radius: 4px;
  background-color: #ee2e24;
  color: white;
  :hover:enabled {
    background-color: #ee2e24 !important;
  }
`;

export const LessPaddingButton = styled(Button)`
  font-size: 14px;
  padding: 4px;
  border-radius: 6px;
`;

export const EqualPaddingButton = styled(Button)`
  font-size: 14px;
  border-radius: 6px;
  padding: 5px 10px 5px 10px;
`;

export const CardWithMarginAndPadding = styled(Card)`
  margin-bottom: 3rem;
  padding: 2rem !important;
`;

export const UnderLineRedPointerTypography = styled(Typography)`
  text-decoration: underline;
  color: red;
  cursor: pointer;
  margin: 1rem !important;
`;

export const RowDisplayRadioGroup = styled(RadioGroup)`
  display: flex !important;
  flex-direction: row;
  justify-content: space-between;
  gap: 5rem;
`;

export const ErrorTypography = styled(MuiTypography)`
  margin: 4px 14px 0 14px;
  color: red;
`;

export const ExtraRLPaddingButton = styled(Button)`
  font-size: 14px;
  border-radius: 6px;
  padding: 5px 40px 5px 40px;
  margin-left: 10px;
`;

export const SolidGreyBorderBox = styled(Box)`
  border: 1px solid #ccc;
`;

export const DefaultNoDataFound = styled.div`
  padding: 40px 0 30px;
`;

export const NoDataFound = styled.div`
  padding: 40px 0 30px;

  .no-data-label {
    font-weight: 600;
  }

  p:has(.criteria-label) {
    margin: 8px 0;
  }
`;

export const DefaultRadiusButton = styled(Button)`
  font-size: 12px;
  padding: 6px;
  border-radius: 6px;
`;

export const StyledListItemTextLeft = styled(ListItemText)`
  padding-top: 24px;
  padding-bottom: 18px;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
`;

export const LeftAlignTypography = styled(Typography)`
  font-weight: 600;
  text-align: left;
`;

export const MTErrorTypography = styled(Typography)`
  color: red;
  margin-top: 5px;
`;

export const MarginLeftErrorTypography = styled(Typography)`
  color: red;
  float: right;
  width: 75%;
`;
export const StyledContainer = styled.div`
  clear: both;
  overflow: hidden;
  padding: 0px 1rem;
  margin-top: -0.8rem;
`;

export const PaddingAndMBCard = styled(Card)`
  padding: 2rem;
  margin-bottom: 2rem;
`;

export const FixedHeightListItemText = styled(ListItemText)`
  height: 6rem;
`;

export const RightAlignFormerText = styled(FormHelperText)`
  width: 75%;
  float: right;
`;

export const RightAlignPaddingFormerText = styled(FormHelperText)`
  width: 75%;
  float: right;
  padding: 0 14px !important;
`;

export const SolidBorderBox = styled(Box)`
  border-bottom: 1px solid #eee;
`;

export const BoxContentDisplayCenter = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`;

export const BoxContentDisplayCenterNoGap = styled(Box)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const RowReverseErrorTypography = styled(Typography)`
  color: red;
  display: flex;
  flex-direction: row-reverse;
`;

export const MLButton = styled(Button)`
  margin-left: 0.5rem !important;
  margin: 0;
`;

export const CenteredBox = styled(Box)`
  display: flex;
  align-items: center;
`;

export const GridWordBreakWrapper = styled(Grid)`
  word-break: break-all;
`;

export const SolidBorderShadowPaddingTable = styled(Table)`
  border: 1px solid #eee;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.2);
  padding: 5px !important;
`;

export const PRCenteredTypography = styled(Typography)`
  display: flex;
  align-items: center;
  padding-right: 15px;
`;

export const StyledLightGreyBox = styled(Box)`
  border-bottom: solid 2px lightgrey;
`;

export const FixedHeightCenteredGrid = styled(Grid)`
  height: 100px;
  justify-content: center;
  align-content: center;
`;

export const CenteredGapTypography = styled(Typography)`
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const StyledTypography = styled(Typography)`
  padding-bottom: 10px;
`;

export const UnderLineButton = styled(Button)`
  text-decoration: underline;
`;

export const FixedWidthFormHelperText = styled(FormHelperText)`
  width: 75%;
  padding: 0px !important;
`;

export const FormControlWrapper = styled(FormControl)`
  &.form-control {
    width: 280px;
    margin-bottom: 10px;
    height: fit-content;

    .multi-select {
      margin-top: 2px;
      background-color: white;

      &::before,
      &:hover,
      &::after {
        border-bottom: none !important;
      }

      .MuiSelect-select {
        padding: 7px 20px 2px 8px;
        border: 1px solid ${(props) => props.theme.greyAdobe1};
        font-size: 12px;
        height: 24px;

        &:focus-visible {
          outline: none;
        }

        &:focus {
          background-color: white;
        }
      }

      &.error .MuiSelect-select {
        border-color: ${(props) => props.theme.primaryColor};

        .placeholder-text {
          color: ${(props) => props.theme.primaryColor};
        }
      }
    }

    &:has(.error) {
      label {
        color: ${(props) => props.theme.primaryColor};
      }
    }
  }
`;

export const LabelWrapper = styled.label`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StyledLoader = styled(Loading)`
  &.loading-component {
    position: unset;
  }
`;

export const PaginatorWrapper = styled.div<{
  justifyContent?: string;
  paddingBlock?: string;
}>`
  display: flex;
  justify-content: ${(props) => props?.justifyContent || "end"};
  border-top: 1px solid ${(props) => props.theme.greyBackground};
  width: 100%;
  padding-block: ${(props) => props?.paddingBlock || "16px"};
`;

export const TextFieldWrapper = styled(TextField)<{ radius?: string }>`
  .MuiInputBase-root {
    border-radius: ${(props) => props.radius || "0"};
  }
`;

export const FormRow = styled.div`
  clear: both;
  overflow: hidden;
  padding: 5px 10px;
  margin-bottom: 10px;
`;

export const StyledWidthFormControl = styled(FormControl)<{ width?: string }>`
  width: ${(props) => props.width || "100%"};
`;

export const StyledIconButton = styled(IconButton)`
  cursor: pointer;
  &:hover {
    background-color: transparent !important;
  }
`;

export const StyledTableCell = styled(Table.Cell)`
  padding: 0px;
`;

export const StyledEllipsisTableCell = styled(Table.Cell)<{
  maxwidth?: string;
}>`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: ${(props) => props.maxwidth || "170px"};
`;

export const CursorPointerDownloadIcon = styled(DownloadIcon)<{
  expired: string;
}>`
  cursor: ${({ expired }) => (expired === "true" ? "not-allowed" : "pointer")};
  color: ${({ expired }) => expired === "true" && "gray"};
  opacity: ${({ expired }) => (expired === "true" ? EXPIRED_OPACITY : 1)};
  pointer-events: ${({ expired }) => (expired === "true" ? "none" : "auto")};
`;

export const RadioGroupWrapper = styled(RadioGroup)`
  width: 100%;
`;

export const DialogHeader = styled(DialogTitle)`
  background: ${(props) => props.theme.greyBackground};

  &.dialog-header {
    padding: 10px 24px;
  }
`;

export const StyledKeyboardArrowDownIcon = styled(KeyboardArrowDownIcon)`
  margin-right: 10px;
`;

export const StyledKeyboardArrowRightIcon = styled(KeyboardArrowRightIcon)`
  margin-right: 10px;
`;

export const NoHoverWithBorderRow = styled(Table.Row)`
  &:hover {
    background-color: inherit !important;
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  &.select-all-selected,
  &:hover.select-all-selected {
    background-color: rgba(238, 46, 36, 0.08);
  }
`;

export const ExpirableTableRow = styled(Table.Row)<{
  expired?: string | null;
  status?: string | null;
}>`
  ${({ expired, status }) =>
    expired === "true" && status === "completed"
      ? `
        opacity: ${EXPIRED_OPACITY};
        background-color: #f9f9f9 !important;
        color: gray;

        * {
          color: gray !important;
        }

        &:hover {
          background-color: #f9f9f9 !important;
        }
      `
      : `
        opacity: 1;
        color: inherit;
      `}
`;

export const SanctionBox = styled(Box)`
  border: 1px solid #cbcbcb;
  padding: 2%;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const SanctionHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const StyledRadioGroup = styled(RadioGroup)`
  width: 75%;
  float: right;
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem 1.5rem;
  margin-top: -0.8rem;
`;

export const StyledToggleWrapper = styled.div<{ checked?: boolean }>`
  width: 75%;
  float: right;
  margin-left: ${({ checked }) => (checked ? "-1.2rem" : "-1rem")};
  transition: margin-left 0.2s ease-in-out;
`;

export const StyledFormGroup = styled(FormGroup)`
  width: 75%;
  float: right;
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem 1.5rem;
  margin-top: -0.8rem;
`;

export const StyledWarningAlert = styled(Alert)`
  width: fit-content;
  margin-left: 25%;
  font-size: 14px;
  align-items: center;
  clear: both;

  .MuiAlert-icon {
    padding: 0px;
  }
`;

export const StyledSliderWrapper = styled.div`
  width: 75%;
  float: right;
  display: flex;
  justify-content: flex-start;
`;

export const StyledDatePickerWrapper = styled.div`
  width: 75%;
  float: right;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0px;
`;

export const StyledCriteriaForm = styled.div`
  width: 100%;
  padding-left: 6rem;
  padding-right: 15rem;
`;

export const StyledFormRow = styled(FormRow)`
  padding-top: 2rem;
  display: flex;
`;

export const CustomStepper = styled(Stepper)({
  "& .MuiStepLabel-root": {
    "& .MuiStepLabel-label": {
      fontSize: "1.5rem",
    },
    "& .MuiStepIcon-root": {
      width: 40,
      height: 40,
    },
    "& .Mui-completed": {
      color: "#4caf50",
    },
    "& .MuiStepLabel-label.Mui-completed": {
      color: "#000000",
    },
    "& .MuiStepLabel-label.Mui-active": {
      fontWeight: "bold",
    },
    padding: "0",
  },
  "& .MuiStepConnector-root": {
    top: 20,
  },
  "& .MuiStepIcon-text": {
    fontWeight: "bold",
  },
  "& .MuiStep-root": {
    padding: "0",
  },
  marginTop: "24px",
  marginBottom: "24px",
});

export const ButtonContainer = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "1.6rem",
  marginRight: "3rem",
});

export const StepperContainer = styled(Box)({
  marginLeft: "3rem",
  marginRight: "3rem",
});

export const ErrorMessage = styled(Typography)`
  color: red;

  &.monitoring-warning {
    font-size: 16px;
  }
`;

export const DateValidator = styled(Typography)`
  color: red;
  padding-top: 8px;

  &.monitoring-warning {
    font-size: 16px;
  }
`;

export const FormLabelBold = styled.label`
  font-weight: 600;
  width: 25%;
`;
